/**
 * Reducers specify how the application's state changes in response to actions sent to the store.
 *
 * @see https://redux.js.org/basics/reducers
 */
import { createReducer } from 'reduxsauce';
import { LspDelOrdIndexTypes } from './Actions';
import INITIAL_STATE from './InitialState';

export const lspDelOrdIndexResetTimestamp = (state, { currentPage, sorts, filters, pageSize }) => ({
  ...state,
  currentPage: currentPage || state.currentPage,
  sorts: sorts || state.sorts,
  filters: filters || state.filters,
  pageSize: pageSize || state.pageSize,
  timestamp: Date.now(),
  selectedDocuments: []
});

export const lspDelOrdIndexFetchLspDelOrdIndexLoading = (state, { boolean }) => ({
  ...state,
  fetchIsLoading: boolean
});

export const lspDelOrdIndexFetchLspDelOrdIndexSuccess = (
  state,
  { documents, currentPage, lastPage, total, pageSize }
) => ({
  ...state,
  documents,
  currentPage,
  lastPage,
  total,
  pageSize
});

export const lspDelOrdIndexAddSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = state.selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: [
      ...state.selectedDocuments,
      ...selectedDocuments.filter(data => {
        return !selectIds.includes(data.id);
      })
    ]
  };
};

export const lspDelOrdIndexRemoveSelectedDocuments = (state, { selectedDocuments }) => {
  const selectIds = selectedDocuments.map(value => value.id);
  return {
    ...state,
    selectedDocuments: state.selectedDocuments.filter(data => {
      return !selectIds.includes(data.id);
    })
  };
};

export const lspDelOrdIndexSetWorkspaceVisible = (state, { boolean }) => ({
  ...state,
  workspaceIsVisible: boolean
});

export const lspDelOrdIndexWorkspaceLoading = (state, { boolean }) => ({
  ...state,
  workspaceIsLoading: boolean
});

/**
 * @see https://github.com/infinitered/reduxsauce#createreducer
 */
export const reducer = createReducer(INITIAL_STATE, {
  [LspDelOrdIndexTypes.LSP_DEL_ORD_INDEX_RESET_TIMESTAMP]: lspDelOrdIndexResetTimestamp,
  [LspDelOrdIndexTypes.LSP_DEL_ORD_INDEX_FETCH_LSP_DEL_ORD_INDEX_LOADING]: lspDelOrdIndexFetchLspDelOrdIndexLoading,
  [LspDelOrdIndexTypes.LSP_DEL_ORD_INDEX_FETCH_LSP_DEL_ORD_INDEX_SUCCESS]: lspDelOrdIndexFetchLspDelOrdIndexSuccess,
  [LspDelOrdIndexTypes.LSP_DEL_ORD_INDEX_ADD_SELECTED_DOCUMENTS]: lspDelOrdIndexAddSelectedDocuments,
  [LspDelOrdIndexTypes.LSP_DEL_ORD_INDEX_REMOVE_SELECTED_DOCUMENTS]: lspDelOrdIndexRemoveSelectedDocuments,
  [LspDelOrdIndexTypes.LSP_DEL_ORD_INDEX_SET_WORKSPACE_VISIBLE]: lspDelOrdIndexSetWorkspaceVisible,
  [LspDelOrdIndexTypes.LSP_DEL_ORD_INDEX_WORKSPACE_LOADING]: lspDelOrdIndexWorkspaceLoading
});
